import { Component } from 'react';
import { bool, func } from 'prop-types';
import { Switch, Route } from 'react-router-dom';

import GlossaryOverview from './GlossaryOverview';
import GlossaryTerm from './GlossaryTerm';
import GlossaryData from './GlossaryData';

/**
 * Glossary Routes is a simple `react-router` Switch and Route setup
 * so we have a single-source-of-routing-truth in both Glossary and GlossaryModal.
 * If Glossary and GlossaryModal are joined together in one file we could re-add this logic there as well.
 */
class GlossaryRoutes extends Component {
  render() {
    const { modal, hide, openFromSide } = this.props;

    return (
      <GlossaryData>
        {({ glossary, setGlossary, userCanEdit }) => {
          return (
            <Switch>
              <Route
                exact
                path={'/glossary'}
                render={() => (
                  <GlossaryOverview
                    loading={glossary.loading}
                    modal={modal}
                    hide={hide}
                    userCanEdit={userCanEdit}
                    {...glossary}
                  />
                )}
              />
              <Route
                exact
                path={'/glossary/:category/:term?'}
                render={({ match }) => (
                  <GlossaryTerm
                    loading={glossary.loading}
                    modal={modal}
                    hide={hide}
                    category={match.params.category}
                    term={match.params.term}
                    userCanEdit={userCanEdit}
                    setGlossary={setGlossary}
                    {...glossary}
                    openFromSide={openFromSide}
                  />
                )}
              />
            </Switch>
          );
        }}
      </GlossaryData>
    );
  }
}

GlossaryRoutes.defaultProps = {
  modal: false,
};

GlossaryRoutes.propTypes = {
  /**
   * Indicates if the content in the page should assume it's in a modal window, which helps if you're navigating with Links and have to set the modal State
   */
  modal: bool,
  /** The action to perform when clicking on the close button, only needed when modal is set to true */
  hide: func,
};

export default GlossaryRoutes;
